import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAllCampaigns } from "../app/api/campaign";
import { Campaign } from "../types";
import { fetchAllPaymentLinkDonations, fetchAllPaymentLinks } from "../app/api/paymentLink";

export function usePaymentLinks() {
  return useQuery<any[], Error>({
    queryKey: ["paymentLinks"],
    queryFn: fetchAllPaymentLinks,
    staleTime: 1000,
    retry: 1,
  });
}
export function usePaymentLinkDonations() {
  return useQuery<any[], Error>({
    queryKey: ["paymentLinks-donations"],
    queryFn: fetchAllPaymentLinkDonations,
    staleTime: 1000,
    retry: 1,
  });
}
